module.exports = __webpack_public_path__ + "img/logo_sowos_wealth.d7e5bac3.svg";